jQuery(document).ready(function () {
  jQuery(".swiper-load-fade").each(function () {
    var swiper_section = jQuery(this);

    swiper_section.imagesLoaded(function () {
      swiper_section.addClass("swiper-loaded");
    });
  });

  if (
    typeof ScrollMagic === "undefined" ||
    typeof TweenMax === "undefined" ||
    typeof TimelineMax === "undefined"
  ) {
    return;
  }

  var controller = new ScrollMagic.Controller();

  /**
   * Background word/parallax-ish animation
   */
  var animateBackgroundWord = Array.prototype.slice.call(
    document.querySelectorAll(".snug-to-margin")
  );

  animateBackgroundWord.forEach(function (section) {
    var text = section.querySelectorAll(".bg-effect");

    if (!text.length) return;

    var hasPlayed = false;
    var sceneOne = new TimelineMax({ paused: true });

    TweenMax.set(text, { y: 130 });

    sceneOne.to(text, 0.5, {
      y: -150
    });

    new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: "onEnter",
      duration: 10000,
      offset: 0
    })
      .setTween(sceneOne)
      .setClassToggle(section, "active")
      .on("enter", function () {
        sceneOne.play(0);
      })
      .on("leave", function (event) {
        if (event.scrollDirection === "REVERSE") {
          sceneOne.pause(0);
        }
      })
      .addTo(controller);
  });

  /**
   * Grid fade
   */
  var animateGrid = Array.prototype.slice.call(
    document.querySelectorAll(".grid-fade")
  );

  animateGrid.forEach(function (section) {
    var gridItems = section.querySelectorAll(".row .grid-item");

    if (!gridItems.length) return;

    var hasPlayed = false;
    var gridScene = new TimelineMax({ paused: true });

    TweenMax.set(gridItems, {
      opacity: 0,
      y: 20
    });

    gridScene.staggerTo(
      gridItems,
      0.8,
      {
        opacity: 1,
        y: 0
      },
      0.1
    );

    new ScrollMagic.Scene({
    triggerElement: section,
    triggerHook: 0.85,
    duration: 0,
    offset: 0
  })
    .setClassToggle(section, "active")
    .on("enter", function () {
      gridScene.play(0);
    })
    .on("leave", function (event) {
      if (event.scrollDirection === "REVERSE") {
        gridScene.pause(0);
      }
    })
    .addTo(controller);
    });

  /**
   * Text fade
   */
  var animateTextFade = Array.prototype.slice.call(
    document.querySelectorAll(".text-fade")
  );

  animateTextFade.forEach(function (section) {
    var headings = section.querySelectorAll(
      "h1, h2, h3, h4, .sub"
    );

    var textBlocks = section.querySelectorAll(
      "p, ul, ol"
    );

    var buttons = section.querySelectorAll(
      "a.butt"
    );

    var miniRules = section.querySelectorAll(
      "hr.mini"
    );

    var hasPlayed = false;
    var textScene = new TimelineMax({ paused: true });

    TweenMax.set(headings, {
      opacity: 0,
      y: 10
    });

    TweenMax.set(textBlocks, {
      opacity: 0,
      y: 10
    });

    TweenMax.set(buttons, {
      opacity: 0,
      y: 10
    });

    TweenMax.set(miniRules, {
      opacity: 0,
      y: 10,
      width: 0
    });

    if (headings.length) {
      textScene.to(headings, 0.8, {
        opacity: 1,
        y: 0
      });
    }

    if (textBlocks.length) {
      textScene.to(
        textBlocks,
        0.8,
        {
          opacity: 1,
          y: 0
        },
        headings.length ? "-=0.45" : 0
      );
    }

    if (buttons.length) {
      textScene.to(
        buttons,
        0.8,
        {
          opacity: 1,
          y: 0
        },
        "-=0.45"
      );
    }

    if (miniRules.length) {
      textScene.to(
        miniRules,
        0.8,
        {
          opacity: 1,
          y: 0,
          width: 100
        },
        "-=0.45"
      );
    }

    new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0.85,
      duration: 0,
      offset: 0
    })
      .setClassToggle(section, "active")
      .on("enter", function () {
        textScene.play(0);
      })
      .on("leave", function (event) {
        if (event.scrollDirection === "REVERSE") {
          textScene.pause(0);
        }
      })
      .addTo(controller);
  });

  /**
   * Two column fade
   */
  var animateTwoColumn = Array.prototype.slice.call(
    document.querySelectorAll(".two-col-fade")
  );

  animateTwoColumn.forEach(function (section) {
    var colFirst = section.querySelectorAll(".col-first .inner");
    var colSecond = section.querySelectorAll(".col-second");

    if (!colFirst.length && !colSecond.length) return;

    var hasPlayed = false;
    var twoColumnScene = new TimelineMax({ paused: true });

    TweenMax.set(colFirst, {
      opacity: 0,
      x: -10
    });

    TweenMax.set(colSecond, {
      opacity: 0,
      x: 10
    });

    if (colFirst.length) {
      twoColumnScene.to(colFirst, 0.8, {
        opacity: 1,
        x: 0
      });
    }

    if (colSecond.length) {
      twoColumnScene.to(
        colSecond,
        0.8,
        {
          opacity: 1,
          x: 0
        },
        colFirst.length ? "-=0.45" : 0
      );
    }

    new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0.85,
      duration: 0,
      offset: 0
    })
      .setClassToggle(section, "active")
      .on("enter", function () {
        twoColumnScene.play(0);
      })
      .on("leave", function (event) {
        if (event.scrollDirection === "REVERSE") {
          twoColumnScene.pause(0);
        }
      })
      .addTo(controller);
  });

  /**
   * Timeline entries fade
   */
  var animateTimelineEntries = Array.prototype.slice.call(
    document.querySelectorAll("section.timeline .row .timeline-entry")
  );

  animateTimelineEntries.forEach(function (entry) {
    var hasPlayed = false;
    var timelineScene = new TimelineMax({ paused: true });

    TweenMax.set(entry, {
      opacity: 0,
      y: 20
    });

    timelineScene.to(entry, 0.8, {
      opacity: 1,
      y: 0
    });

    new ScrollMagic.Scene({
      triggerElement: entry,
      triggerHook: 0.85,
      duration: 0,
      offset: 0
    })
      .setClassToggle(entry, "active")
      .on("enter", function () {
        if (hasPlayed) return;

        hasPlayed = true;
        timelineScene.play();
      })
      .addTo(controller);
  });
});